module.exports = __webpack_public_path__ + "static/tattoo1-3d933fb0c2b579f5fc3f6ca25c867ffa.jpg";